import { Text } from "@mantine/core";
import type { DashboardReportMeta, DashboardReportRun } from "../../../types/api";
import { axioTokens } from "../../../theme";
import { formatReportValue } from "../formatReportValue";

interface InfoCardWidgetProps {
  report: DashboardReportMeta;
  run: DashboardReportRun;
}

export function InfoCardWidget({ report, run }: InfoCardWidgetProps) {
  const format = (report.interpretation_json.format ?? report.config_json.format) as
    | { value?: string; suffix?: string }
    | undefined;
  const isPaise =
    format?.value === "paise" || report.key.endsWith("_paise");
  const resolvedFormat =
    isPaise
      ? { ...format, value: "paise" as const }
      : format;

  const display = formatReportValue(run.data.value, resolvedFormat);

  if (isPaise) {
    // Split rupee symbol for money signature typography
    const match = display.match(/^(₹\s?)(.*)$/);
    if (match) {
      return (
        <Text
          fw="var(--axio-font-weight-bold)"
          size="xl"
          lh="var(--axio-line-height-compact)"
          className="moneyAmount"
          style={{ fontFamily: axioTokens.fontHead }}
        >
          <span className="rupee">{match[1].trim()}</span>
          {match[2]}
        </Text>
      );
    }
  }

  return (
    <Text
      fw="var(--axio-font-weight-bold)"
      size="xl"
      lh="var(--axio-line-height-compact)"
      className="tabular"
      style={{ fontFamily: axioTokens.fontHead, letterSpacing: "var(--axio-letter-spacing-tight)" }}
    >
      {display}
    </Text>
  );
}
